<!-- 饼图 -->
<style lang="stylus" scoped>
.circleBar {
  height: 250px;
  padding: 20px 0;
  box-sizing: border-box;
  overflow: hidden;

  .main {
    width: 100%;
    height: 100%;
  }

  .active-item {
    width: 100%;
    height: 32px;
    margin-bottom: 8px;
    line-height: 32px;
  }

  .active-item i, .active-item .item-name-num, .active-item span, .active-item em {
    float: left;
    height: 100%;
    color: #fff;
    font-size: 20px;
    font-style: normal;
    box-sizing: border-box;
  }

  .active-item .item-rank {
    width: 35px;
    // color: #fff;
    text-align: center;
    margin-right: 8px;
  }

  .active-item .item-name-num {
    width: 400px;
    // border-bottom: 1px solid rgba(0, 108, 243, 0.65);
    position: relative;
  }

  .active-item .item-name-num .item-name {
    padding-left: 10px;
    // border-right: 1px solid rgba(0, 108, 243, 0.65);
    word-break: keep-all;
    // background: linear-gradient(to right, #040B58, #0A30B1);
  }

  .active-item .item-name-num .item-num {
    float: right;
    font-size: 16px;
    color: #00fefb;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="circleBar">
      <!-- <div class="main"></div> -->
      <!-- <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="data.length!=0">
        <swiper-slide v-for="(item,index) in data" :key="index" class="active-item">
          <i class="item-rank" :style="changeColor(index)">{{index+1}}</i>
          <div class="item-name-num">
            <span class="item-name">{{item.name}}</span>
            <em class="item-num">{{item.num}}</em>
          </div>
        </swiper-slide>
      </swiper> -->
      <div v-for="(item,index) in data" :key="index" class="active-item">
        <i class="item-rank" :style="changeColor(index)">{{index+1}}</i>
        <div class="item-name-num">
          <span class="item-name">{{item.name}}</span>
          <em class="item-num">{{item.num}}</em>
        </div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '农安信用排名',
      circleBarData: [
        { value: 19.05, name: '质量安全评估信息' },
        { value: 4.76, name: '其他信息' },
        { value: 14.29, name: '奖励信息' },
        { value: 9.52, name: '监督检查信息' },
        { value: 14.29, name: '认证(登记)信息' },
        { value: 14.28, name: '行政处罚' },
        { value: 19.05, name: '行政许可信息' },
        { value: 9.52, name: '基础信息' }
      ],
      data: [
        { name: '田阳山友现代农业综合开发有限公司', num: 882 },
        { name: '百色市右江区陆东芒果种植农民专...', num: 834 },
        { name: '田阳县鲜吃道农业开发有限公司公司', num: 818 },
        { name: '广西田阳赶街农业综合开发有限公司', num: 792 },
        { name: '广西田阳县鲜加原商贸有限公司 ', num: 784 },
        { name: '广西田阳县阳帆农牧科技有限公司', num: 775 },
        { name: ' 田阳县百育惠先农业开发有限公司', num: 771 },
        { name: '广西壮乡河谷农业科技有限公司', num: 768 },
        { name: ' 广西田阳煦日农业科技有限公司', num: 763 },
        { name: '田阳新生农业有限公司', num: 761 }
      ],
      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#fff'],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  methods: {
    // init() {
    //   window.addEventListener('resize', function() {
    //     this.myChart.resize()
    //   }.bind(this))
    // }
    changeColor(index) {
      if (index <= 3) {
        return `color:${this.colorList[index]}`
      } else {
        return `color:${this.colorList[3]}`
      }
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    // this.myChart = echarts.init(document.querySelector('.circleBar .main'));
    // this.myChart.setOption({
    //   tooltip: {
    //     show: false
    //   },
    //   legend: {
    //     show: false
    //   },
    //   color: this.color,
    //   series: [
    //     {
    //       type: 'pie',
    //       selectedMode: 'single',
    //       radius: [0, '40%'],
    //       label: {
    //         normal: {
    //           show: false,
    //           position: 'inner',
    //           formatter: '{d}%',
    //           textStyle: {
    //             color: '#fff',
    //             fontWeight: 'normal',
    //             fontSize: 20
    //           }
    //         }
    //       },
    //       labelLine: {
    //         normal: {
    //           show: false
    //         }
    //       },
    //       data: this.circleBarData
    //     },
    //     {
    //       type: 'pie',
    //       radius: ['50%', '55%'],
    //       label: {
    //         normal: {
    //           formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',
    //           rich: {
    //             b: {
    //               fontSize: 14,
    //               color: '#fff',
    //               align: 'left',
    //               padding: 4
    //             },
    //             hr: {
    //               borderColor: '#12EABE',
    //               width: '100%',
    //               borderWidth: 2,
    //               height: 0
    //             },
    //             d: {
    //               fontSize: 14,
    //               color: '#fff',
    //               align: 'left',
    //               padding: 4
    //             },
    //             c: {
    //               fontSize: 14,
    //               color: '#fff',
    //               align: 'center',
    //               padding: 4
    //             }
    //           }
    //         }
    //       },
    //       labelLine: {
    //         normal: {
    //           show: true,
    //           length: 20,
    //           length2: 20
    //         }
    //       },
    //       data: this.circleBarData
    //     }
    //   ]
    // })
    // this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?3cbc95d6